
import React from "react";

import "./MsgDialog.scss";

const MsgDialog = ({ children, open, handleMsgDialog, htmlClasses, isSaveDlg = false }) => {
    return (
        <div className={isSaveDlg ? 'advanced-savedialog' : 'advanced-msgdialog'}>
            <div className={open ? `msgdialog ${htmlClasses ? htmlClasses : 'show'}` : 'msgdialog'}>
                {children}
            </div>
            {/* <div className="msgdialog-overlay" onClick={() => handleMsgDialog(false)} /> */}
            <div className="msgdialog-overlay" />
        </div>
    )
}

export default MsgDialog;